import { Row, Select } from "antd";
import { useState, useEffect } from "react";
import moment from "moment";

const { Option } = Select;

export const SelectCustomCarreras = ({
  idCampo,
  nombreCampo,
  arrayOpciones,
  textoOpciones,
  elValue,
  elPlaceholder,
  required,
  tipoError,
  error,
  onChange,
}) => {
  const [selectedValue, setSelectedValue] = useState(elValue || null);
  let esRequired = required ? "*" : "";

  useEffect(() => {
    setSelectedValue(elValue || null);
  }, [elValue]);

  const handleSelectChange = (selectedValue) => {
    setSelectedValue(selectedValue);
    onChange({ target: { value: String(selectedValue), id: idCampo } });
  };

  return (
    <Row >
      <label htmlFor={idCampo}>
        <p className="nombre-campo">{nombreCampo} {esRequired}</p>
      </label>
      <Select
      className="select-custom"
        showSearch
        autoComplete="none"
        key={idCampo + "-" + elValue}
        id={idCampo}
        onChange={handleSelectChange}
        placeholder={elPlaceholder}
        style={{ width: "100%" }}
        required={required}
        value={selectedValue !== null ? String(selectedValue) : undefined}
        filterOption={(input, option) =>
          (String(option.children) || "").toLowerCase().includes(input.toLowerCase())
        }
        status={tipoError}
      >
        <Option key={"vacio"} value="">
          Seleccione una carrera
        </Option>
        {arrayOpciones.map((option) => (
          <Option key={option.id} value={String(option.id)}>
            {moment(option["dia"]).format("DD/MM/YYYY")}-{option["circuito"].nombre},{option["circuito"].localidad}
          </Option>
        ))}
      </Select>
      <span className="spanErrores" style={{ color: "red" }}>
        <b>{error}</b>
      </span>
    </Row>
  );
};
